/** @jsxRuntime classic */
/** @jsx jsx */
import { StaticImage } from 'gatsby-plugin-image';
import { jsx } from 'theme-ui';
import Ad from './Ad';

export default function ACA(rest: JSX.IntrinsicAttributes) {
  return (
    <Ad
      url="https://www.fendt-janu.at/2008/?mtm_campaign=VieVinum2022&mtm_placement=web-desktop"
      mobileUrl="https://www.fendt-janu.at/2008/?mtm_campaign=VieVinum2022&mtm_placement=web-mobile "
      desktopImage={
        <StaticImage
          src="./janu-728x90-2x.png"
          width={728}
          height={90}
          alt="ACA Center Janu"
        />
      }
      mobileImage={
        <StaticImage
          src="./janu-300x200-2x.png"
          width={300}
          height={200}
          alt="ACA Center Janu"
        />
      }
      {...rest}
    />
  );
}
